"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var Model_1 = require("../Model");
var TourCollation = /** @class */ (function (_super) {
    __extends(TourCollation, _super);
    function TourCollation(id, tourId, shipmentId, position, polyline) {
        var _this = _super.call(this, id) || this;
        _this.setTourId = tourId;
        _this.setShipmentId = shipmentId;
        _this.setPosition = position;
        _this.setPolyline = polyline;
        _this.fetchTour = _this.fetchTour.bind(_this);
        _this.fetchShipment = _this.fetchShipment.bind(_this);
        _this.fetchEstimation = _this.fetchEstimation.bind(_this);
        return _this;
    }
    TourCollation.prototype.hasEstimations = function () {
        return this.estimation !== undefined;
    };
    TourCollation.prototype.fetchTour = function () {
        return this.fetchNestedModel('setTour', __1.Tour.fetch, 'getTourId');
    };
    TourCollation.prototype.fetchShipment = function () {
        if (!this.getShipmentId || this.getShipmentId < 0) {
            return Promise.resolve(undefined);
        }
        return this.fetchNestedModel('setShipment', __1.Shipment.fetch, 'getShipmentId');
    };
    TourCollation.prototype.fetchEstimation = function () {
        if (this.getId) {
            return this.fetchNestedModel('setEstimation', __1.Estimation.fetchByCollationId, 'getId');
        }
        return true;
    };
    Object.defineProperty(TourCollation.prototype, "getTourId", {
        /**
         * GETTERS
         */
        get: function () {
            return this.tourId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getTour", {
        get: function () {
            return this.checkIfPropertyIsFetched('tour', this.fetchTour);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getShipmentId", {
        get: function () {
            return this.shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getShipment", {
        get: function () {
            return this.checkIfPropertyIsFetched('shipment', this.fetchShipment);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getPosition", {
        get: function () {
            return this.position;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getPolyline", {
        get: function () {
            return this.polyline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "getEstimation", {
        get: function () {
            return this.checkIfPropertyIsFetched('estimation', this.fetchEstimation);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setTourId", {
        /**
         * SETTERS
         */
        set: function (tourId) {
            this.tourId = tourId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setTour", {
        set: function (tour) {
            this.tour = tour;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setShipmentId", {
        set: function (shipmentId) {
            this.shipmentId = shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setShipment", {
        set: function (shipment) {
            this.shipment = shipment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setPosition", {
        set: function (position) {
            this.position = position;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setPolyline", {
        set: function (polyline) {
            this.polyline = polyline;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TourCollation.prototype, "setEstimation", {
        set: function (estimations) {
            this.estimation = Array.isArray(estimations)
                ? estimations.pop()
                : estimations;
        },
        enumerable: true,
        configurable: true
    });
    TourCollation.fetch = function (collationId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, TourCollation.makeRequest("/spatial/private/tour-collation/" + collationId, Model_1.METHOD.GET)];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, new TourCollation(result.id, result.tourId, result.shipmentId, result.position, result.polyline)];
            }
        });
    }); };
    TourCollation.fetchByTourId = function (tourId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, TourCollation.makeRequest("/spatial/private/tour-collation/", Model_1.METHOD.GET, {
                        filter: {
                            order: {
                                position: "ASC",
                            },
                            where: {
                                tourId: tourId,
                            },
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, result.map(function (item) {
                            return new TourCollation(item.id, item.tourId, item.shipmentId, item.position, item.polyline);
                        })];
            }
        });
    }); };
    TourCollation.fetchByShipmentId = function (shipmentId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, TourCollation.makeRequest("/spatial/private/tour-collation/", Model_1.METHOD.GET, {
                        filter: {
                            order: {
                                id: 'ASC',
                            },
                            where: {
                                shipmentId: shipmentId,
                            },
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, result.map(function (item) {
                            return new TourCollation(item.id, item.tourId, item.shipmentId, item.position, item.polyline);
                        })];
            }
        });
    }); };
    return TourCollation;
}(Model_1.Model));
exports.TourCollation = TourCollation;
